// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa9f6aad","239":"fcaddd2b","453":"8ab44547","553":"df1d4408"}[chunkId] + ".chunk.js";
};